import React from "react";
import { BadgeCard } from "./BadgeCard";

/**
 * The grid the cards are laid out in — two columns on paper, as many as fit on
 * screen. This wrapper class is what every print rule is anchored on, so a
 * badge is only ever printed through here.
 */
export function BadgeSheet({ children }) {
  return <div className="zr-badge-sheet">{children}</div>;
}

/** A sheet of exactly one card: the student-profile entry point. */
export function SingleBadgeSheet({ badge }) {
  return (
    <BadgeSheet>
      <BadgeCard badge={badge} />
    </BadgeSheet>
  );
}
